import RecuperarContraseña from "../../componets/ContainerLogin/RecuperarContraseña";

export default function RecuperarContrasenaPage() {
  return <RecuperarContraseña />;
}

